module.exports = __webpack_public_path__ + "assets/phone_100.ada59e96bb49979a46af1741e08b4fee707d3762b7f14cbd34280f4bb51f2eaf.png";